import { render, staticRenderFns } from "./JsonPreview.vue?vue&type=template&id=67b6fe97&scoped=true&"
import script from "./JsonPreview.vue?vue&type=script&lang=js&"
export * from "./JsonPreview.vue?vue&type=script&lang=js&"
import style0 from "./JsonPreview.vue?vue&type=style&index=0&id=67b6fe97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6fe97",
  null
  
)

export default component.exports